'use es6';

import PropTypes from 'prop-types';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UITextInput from 'UIComponents/input/UITextInput';
import styled from 'styled-components';
import { useDebouncedOnChange } from '../hooks/useDebouncedOnChange';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUITextInput = styled(UITextInput).withConfig({
  displayName: "MarginInput__StyledUITextInput",
  componentId: "sgvtqe-0"
})(["min-width:0;"]);
const propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired
};
function MarginInput(props) {
  const {
    value,
    onChange
  } = props;
  const [handleInputChange, handleStepChange] = useDebouncedOnChange(onChange);
  if (typeof value !== 'number') {
    return /*#__PURE__*/_jsx(StyledUITextInput, {
      disabled: true,
      value: value,
      onChange: handleInputChange,
      size: 7
    });
  }
  return /*#__PURE__*/_jsx(UIStepperInput, {
    min: 0,
    max: 999,
    stepSize: 1,
    size: 3,
    value: value,
    onChange: handleInputChange,
    onStep: handleStepChange
  });
}
MarginInput.propTypes = propTypes;
MarginInput.displayName = 'MarginInput';
export default MarginInput;